import { SearchQueryOrderDirection } from "types/generated";

export const FILTERS_ORDER_SETTINGS_KEY = "modulesSharesNewFiltersOrder";
export const initialSortOption = "type";
export const initialSortDirection = SearchQueryOrderDirection.Desc;
